<div class="h-full">
    @if (isLoading()) {
        <div class="h-full flex flex-col">
            <app-loading
                class="m-auto"
                size="30" />
        </div>
    } @else {
        <app-entity-detail-template
            [attributesInformation]="layerAttributesInformation()"
            [bookmarkedAttributes]="bookmarkedAttributes()"
            [canReadDocuments]="canReadDocuments()"
            [columnsByName]="columnsByName()"
            [dataEntity]="dataEntity()"
            [documentData]="documentData()"
            [geomBboxEntity]="geomBboxEntity()"
            [hasBoxOrBayPlan]="isBoxOrBayPlanAvailable()"
            [hasOpticalPath]="isOpticalPathAvailable()"
            [hasSynoptic]="isSynopticAvailable()"
            [identifier]="identifier"
            [notBookmarkedAttributes]="notBookmarkedAttributes()"
            (centerMapOnEntityAndZoomIn)="centerMapOnEntity()"
            (editGeometryRequested)="requestGeometryEditionFromTable()"
            (exportOpticalPath)="exportOpticalPath()"
            (goToPreviousPage)="goToPreviousPage()"
            (goToSynopticPanel)="openSynopticPanel()"
            (openBoxOrBayPlan)="openBoxOrBayPlan()"
            (openBreakModal)="openBreakModal()"
            (viewOpticalPath)="navigateToNetworkPath()">
            @if (layer()) {
                <div class="flex flex-row items-center">
                    <span class="font-normal text-xl mt-1 break-words">
                        {{ layer()!.name }}
                    </span>
                </div>
            }
        </app-entity-detail-template>
    }
</div>
